if (!customElements.get('mobile-sticky-atc')) {
  customElements.define(
    'mobile-sticky-atc',
    class MobileStickyAtc extends HTMLElement {
      connectedCallback() {
        const targetId = this.dataset.observe;
        const target = targetId && document.getElementById(targetId);

        if (!target || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            this.classList.toggle('mobile-sticky-atc--visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
          },
          { threshold: 0 }
        );

        this.observer.observe(target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
